// extracted by mini-css-extract-plugin
module.exports = {"container":"e_ir","title":"e_jr","titleIcon":"e_kr","summary":"e_lr","sourcesTitle":"e_mr","sources":"e_nr","source":"e_or"};